
























import { Component, Mixins, Watch, Prop } from "vue-property-decorator";
import { DialogSelectableMixin } from "../../system/selectors/mixins";
import { DomainRegistry } from "../../../domain";
import { Patient } from "../../../domain/patient";
import ReceptionPatientSelector from "./ReceptionPatientSelector.vue";
import { DuplicatedPatientIndicator } from "../../patient";
import { WebStorageAccessor } from "../../../store/WebStorageAccessor";

@Component({
  components: {
    ReceptionPatientSelector,
    DuplicatedPatientIndicator,
  }
})
export default class ReceptionPatientDialogSelector extends Mixins(DialogSelectableMixin) {
  @Prop({ default: false })
  viewPatientName: boolean;

  @Prop({ default: false })
  isActive: boolean;

  @Prop()
  shouldFocusOnInitialize: boolean;

  @Prop()
  patientNo: string;

  data() {
    return {
      isFinding: false,
      patientSearchHistory: [] as Patient[],
    };
  }
  isFinding: boolean;
  patientSearchHistory: Patient[];

  mounted() {
    this.applySearchHistory();
  }

  get edittingId(): string {
    return this.editingSource
      ? this.editingSource.id
      : "";
  }

  set edittingId(source: string) {
    if (!source) {
      this.selectedPatient = null;
      return;
    }
    if (!!this.selectedPatient && this.selectedPatient.id === source) {
      return;
    }
    this.findPatient(source);
  }

  get selectedPatient(): Patient {
    return this.editingSource;
  }

  set selectedPatient(source: Patient) {
    if (!this.areEqual(source, this.editingSource)) {
      this.editingSource = source;
      if (source) {
        this.setHistory(source);
      }
    }
  }

  get patientSearchHistoryOptions(): Patient[] {
    return this.searchHistoryEnable
      ? this.patientSearchHistory
      : [];
  }

  get searchHistoryEnable(): boolean {
    return this.$configuration.behavior.reception.list.finder.patient.history.isEnable && this.searchHistoryMaxCount > 0;
  }

  get searchHistoryMaxCount(): number {
    return this.$configuration.behavior.reception.list.finder.patient.history.maxCount;
  }

  private areEqual(source: Patient, destination: Patient): boolean {
    return (source === destination) || (source && destination && source.id === destination.id);
  }

  private applySearchHistory(): void {
    if (!this.searchHistoryEnable) { return; }
    const savedHistoryPatients = WebStorageAccessor.searchedPatients;
    const startIndex = Math.max(savedHistoryPatients.length - this.searchHistoryMaxCount, 0);
    const history = savedHistoryPatients.splice(startIndex, this.searchHistoryMaxCount);
    this.patientSearchHistory = history;
  }

  private setHistory(value: Patient): void {
    if (!this.searchHistoryEnable) { return; }
    if (!(value instanceof Patient)) {
      this.$logger.warn("Patientではないインスタンスです。実装を確認してください。");
      return;
    }
    const savedHistoryPatients = WebStorageAccessor.searchedPatients;
    if (savedHistoryPatients.length === 0) {
      const hisItem = [value];
      WebStorageAccessor.searchedPatients = hisItem;
      this.patientSearchHistory = hisItem;
      return;
    }
    if (this.patientSearchHistory && this.patientSearchHistory.some(h => h.id === value.id)) {
      return;
    }
    if (this.patientSearchHistory && this.patientSearchHistory.length === this.searchHistoryMaxCount) {
      this.patientSearchHistory.shift();
      const saveItems = this.patientSearchHistory.concat(value);
      WebStorageAccessor.searchedPatients = saveItems;
      this.patientSearchHistory = saveItems;
      return;
    }
    const items = this.patientSearchHistory.concat(value);
    WebStorageAccessor.searchedPatients = items;
    this.patientSearchHistory = items;
  }

  private clearPatient(): void {
    this.edittingId = "";
    this.selectedPatient = null;
  }

  private findPatient(patientId: string): void {
    this.isFinding = true;
    const repository = DomainRegistry.patient.getPatientRepository();
    repository.getEntity(patientId)
      .then(p => {
        this.edittingId = p.id;
        this.selectedPatient = p;
        this.isFinding = false;
      })
      .catch(e => {
        console.error(e);
        this.clearPatient();
        this.isFinding = false;
        this.$warn(
          "患者番号不正",
          "入力された患者番号に該当する患者が見つかりませんでした。",
          e,
        );
      });
  }

  @Watch("isActive")
  onIsActiveUpdated(newValue: boolean, oldValue: boolean) {
    if (newValue) {
      this.applySearchHistory();
    }
  }

  onDuplicatedPatientSelected(patient: Patient): void {
    this.edittingId = patient.id;
    this.selectedPatient = patient;
  }
}
